module.exports = __webpack_public_path__ + "img/GY.41725ef9.svg";